<fieldset class="section-legend-border col-md-12 col-lg-12" #LocationFilter>
    <legend class="section-legend-border">Important Point</legend>
    <ul>
        <li>
            Location and sublocation first time Mapping will be done from DB. <b>(Directly to db no entry script required)</b>
        </li>
    </ul>
</fieldset>

<router-outlet (activate)="onActivate($event)"></router-outlet>